import React, { useMemo } from 'react';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import ComponentPageHeader from '../../../Common/PageHeader/ComponentPageHeader';
import { RootState } from '../../../redux/rootState';
import { exportToExcelData } from '../../../Common/PageHeader/helper';
import ComponentFlaggedKitsTable from './Components';

function ScreenFlaggedKits() {
  const { FlaggedKitsData } = useSelector((state: RootState) => state.FlaggedKitsReducer);

  const excelData = useMemo(() => FlaggedKitsData?.Data?.map((item) => {
    const transformedDataItems = {
      Kit_No: item?.Text,
    };
    return transformedDataItems;
  }), [FlaggedKitsData]);

  const downloadExcel = () => {
    exportToExcelData(
      {
        data: excelData,
      },
      'Flagged_Kits_list',
    );
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <ComponentPageHeader subHeading="FLAGGED OIL KITS" downloadExcel={downloadExcel} />
      </Grid>
      <div className="whiteSpace" />
      <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
        <ComponentFlaggedKitsTable />
      </Grid>
    </Grid>
  );
}

export default ScreenFlaggedKits;
